import { inboxType } from "../../../typings/interfaces";

export const MESSAGES_LIST_DIV_ID = "messagesListDiv"

export const AD_ID_PARAM = "adFilterId"
export const USER_ID_PARAM = "userFilterId"
export const INBOX_TYPE_PARAM = "inboxType"

export const CHAT_ITEM_PER_PAGE = 20;

export const CHAT_LIST_OPTIONS = [
    {
        value: inboxType.All,
        title: "Sve",
    },
    {
        value: inboxType.Unread,
        title: "Nepročitane",
    },
    {
        value: inboxType.ForMyAds,
        title: "Za moje oglase",
    },
    {
        value: inboxType.ForOtherAds,
        title: "Za tuđe oglase",
    },
]

export const CHAT_REPORT_REASON_ENUM = 1

export const PAGE_PARAM = "page"

export const TAB_PARAM = "tab";
export const TAB_CHATS = "razgovori";
export const TAB_SYSTEM = "sistemske-poruke";


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/constants/constants.ts